import MailboxTypes from '../schema/MailboxTypes';
import PeopleCardRouteIdType from '../schema/PeopleCardRouteIdType';

/**Returns the people card routeIdType given MailBoxType */
export const getPeopleCardRouteIdType = (mailBoxType: string): PeopleCardRouteIdType => {
    switch (mailBoxType) {
        case MailboxTypes.Mailbox:
        case MailboxTypes.OneOff:
            return PeopleCardRouteIdType.Email;
        case MailboxTypes.GroupMailbox:
        case MailboxTypes.Group:
            return PeopleCardRouteIdType.Group;
        case MailboxTypes.PublicDL:
            return PeopleCardRouteIdType.DL;
        case MailboxTypes.PrivateDL:
            return PeopleCardRouteIdType.CL;
        default:
            return PeopleCardRouteIdType.Email;
    }
};
